<template>
    <div class="help">
      <h1>This is an help page</h1>
    </div>
  </template>
  